import React from "react";
import Box from "@mui/material/Box";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


export default function STBattedBallProfile(props: any) {
  //console.log(props)
  const temp = !Object.keys(props.playerInfoProp).includes('common')
  console.log(temp)

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
        marginTop="10px"
      >
        <Grid maxWidth="90vw">
        <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "300px" :" 100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
              <div
                style={{
                  width: "100%",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  backgroundColor:
                    props.playerData && props.playerData.MLB_AbbName !== null
                      ? teamColors[props.playerData.MLB_AbbName][0]
                      : teamColors["FA"][0],
                }}
              >
                {props.isDesktop &&
                  (<Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="h5">
                      <span
                        style={{
                          color:
                            props.playerData && props.playerData.MLB_AbbName !== null
                              ? teamColors[
                              props.playerData.MLB_AbbName
                              ][1]
                              : teamColors["FA"][1],
                          fontWeight: "bold",
                          fontSize: "25pt",
                          textAlign: "center"
                        }}
                      >
                        Batted Ball Profile
                      </span>
                    </Typography>
                  </Grid>)}
                {!props.isDesktop &&
                  (<Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                  ><Typography variant="h5" style={{ fontSize: "25pt" }}>
                      <div
                        style={{
                          color:
                            props.playerData && props.playerData.MLB_AbbName !== null
                              ? teamColors[
                              props.playerData.MLB_AbbName
                              ][1]
                              : teamColors["FA"][1],
                          fontWeight: "bold",
                          textAlign: "center"
                        }}
                      >
                        Batted Ball Profile
                      </div>
                    </Typography></Grid>)}
              </div>
              <TableContainer component={Paper} style={{margin: "10px"}}>
                {false &&<Table size="small" padding="normal" sx={{ marginLeft: "10px", width: "95%", marginBottom: "0px"  }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >GB%</TableCell>
                        <TableCell >FB%</TableCell>
                        <TableCell >LD%</TableCell>
                        <TableCell >PU%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                      >
                        <TableCell >{50}%</TableCell>
                        <TableCell >{50}%</TableCell>
                        <TableCell >{50}%</TableCell>
                        <TableCell >{50}%</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>}
                <Table size="small" padding="normal" sx={{ marginLeft: "10px", width: "95%", marginBottom: "0px", marginTop: "0px"  }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >Pull%</TableCell>
                        <TableCell >Straight%</TableCell>
                        <TableCell >Oppo%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                      >
                        <TableCell >{(props.playerData.pullair+props.playerData.pullgb).toFixed(1)}%</TableCell>
                        <TableCell >{(props.playerData.straightair+props.playerData.straightgb).toFixed(1)}%</TableCell>
                        <TableCell >{(props.playerData.oppoair+props.playerData.oppogb).toFixed(1)}%</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Table size="small" padding="normal" sx={{ marginLeft: "10px", width: "95%", marginBottom: "0px", marginTop: "0px"    }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >Pull Air%</TableCell>
                        <TableCell >Straight Air%</TableCell>
                        <TableCell >Oppo Air%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                      >
                        <TableCell >{props.playerData.pullair}%</TableCell>
                        <TableCell >{props.playerData.straightair}%</TableCell>
                        <TableCell >{props.playerData.oppoair}%</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Table size="small" padding="normal" sx={{ marginLeft: "10px", width: "95%"  }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >Pull GB%</TableCell>
                        <TableCell >Straight GB%</TableCell>
                        <TableCell >Oppo GB%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                      >
                        <TableCell >{props.playerData.pullgb}%</TableCell>
                        <TableCell >{props.playerData.straightgb}%</TableCell>
                        <TableCell >{props.playerData.oppogb}%</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}